import { motion } from "framer-motion";
import { Check } from "lucide-react";

const tiers = [
  {
    name: "L'Onda",
    price: "€650",
    period: "/ mese",
    level: "Base · Facebook",
    highlighted: false,
    tid: "pack-onda",
    features: [
      "8 contenuti mensili (post/reel) girati in negozio",
      "Copywriting professionale & hashtag strategy",
      "Storie con copertura 3 giorni a settimana",
      "Ottimizzazione costante di bio e highlights",
    ],
    note: "Shooting professionale escluso (extra su richiesta)",
  },
  {
    name: "Lo Tsunami",
    price: "€1.100",
    period: "/ mese",
    level: "Intermedio · FB · TikTok",
    highlighted: true,
    tid: "pack-tsunami",
    features: [
      "12 contenuti mensili (post, reel, TikTok)",
      "Daily storytelling in stories",
      "Gestione campagne Meta Ads locali",
      "Community management e risposta rapida in DM",
      "Report mensile dettagliato con KPI",
    ],
    note: "Budget adv consigliato personalizzato in base agli obiettivi",
  },
  {
    name: "L'Oceano",
    price: "€2.500",
    period: "/ mese",
    level: "Premium · FB · TikTok Strategy",
    highlighted: false,
    tid: "pack-oceano",
    features: [
      "18 contenuti mensili con presidio totale",
      "Presidio community continuo",
      "1 shooting professionale foto & video incluso",
      "Brand identity fisica: listini, vetrine, materiali",
      "SEO + Meta & TikTok Ads avanzati",
      "Presenza fisica per 1 evento a trimestre",
    ],
    note: "Budget adv consigliato personalizzato con media plan dedicato",
  },
];

export default function Pacchetti() {
  return (
    <section id="pacchetti" data-testid="section-pacchetti" className="relative py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl mb-14">
          <div className="text-xs uppercase tracking-[0.3em] text-purple-300/80 mb-4">05 · Pacchetti</div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold tracking-tighter text-white leading-[0.95]">
            Soluzioni modulari, <br /> risultati <span className="text-gradient">misurabili</span>.
          </h2>
          <p className="mt-6 text-slate-400 text-base md:text-lg">
            Tre livelli di collaborazione per farti crescere passo dopo passo, con la flessibilità
            di aggiungere shooting, advertising e servizi extra quando serve.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {tiers.map((t, i) => (
            <motion.div
              key={t.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.7, delay: i * 0.08 }}
              data-testid={t.tid}
              className={`relative rounded-3xl p-8 md:p-10 flex flex-col glass gradient-border ${
                t.highlighted ? "lg:-translate-y-4 shadow-[0_30px_80px_rgba(147,51,234,0.35)]" : ""
              }`}
            >
              {t.highlighted && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 text-[10px] font-semibold uppercase tracking-[0.25em] bg-gradient-to-r from-purple-500 to-blue-500 text-white px-4 py-1.5 rounded-full shadow-lg">
                  Best seller
                </div>
              )}
              <div className="text-xs uppercase tracking-widest text-slate-400">{t.level}</div>
              <h3 className="font-display text-3xl md:text-4xl text-white mt-2">{t.name}</h3>

              <ul className="mt-8 space-y-3 text-slate-300 text-sm flex-1">
                {t.features.map((f) => (
                  <li key={f} className="flex items-start gap-3">
                    <span className="mt-0.5 inline-flex h-5 w-5 items-center justify-center rounded-full bg-purple-500/20 text-purple-300">
                      <Check size={12} strokeWidth={2.5} />
                    </span>
                    <span>{f}</span>
                  </li>
                ))}
              </ul>
              <p className="text-xs text-slate-500 mt-6 leading-relaxed">{t.note}</p>
              <a
                href="#contattaci"
                onClick={(e) => { e.preventDefault(); document.querySelector("#contattaci")?.scrollIntoView({ behavior: "smooth" }); }}
                data-testid={`${t.tid}-cta`}
                className={t.highlighted ? "btn-primary mt-8 justify-center" : "btn-ghost mt-8 justify-center"}
              >
                {t.highlighted ? "Iniziamo" : "Richiedi info"}
              </a>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
